import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';

import { CheckboxGroup } from '@gogame/components';

import { omitFormProps } from '../utils';
import withFormField from './withFormField';

const normalizeValue = (value, data) => {
  if (!value) return undefined;

  const allValues = (data || []).map(({ id }) => id);
  const newValue = (value || []).filter((v) => allValues.includes(v));
  if (newValue.length === value.length) return value;
  if (!newValue.length) return undefined;

  return newValue;
};

const FormCheckboxField = withFormField({
  normalizeValue,
})(({ area, checkboxVertical, ...props }) => {
  return (
    <CheckboxGroup
      vertical={checkboxVertical}
      loading={area.loading}
      options={area.data}
      {...omitFormProps(props)}
    />
  );
});

export default hoistNonReactStatics(FormCheckboxField, CheckboxGroup);
